import type { ReactNode } from 'react';
import {
  NavLink as RouterNavLink,
  NavLinkProps as RouterNavLinkProps,
} from 'react-router-dom-v5-compat';
import { NavLink as AtlasNavLink } from '@diligentcorp/atlas-web-component-global-nav/lib/react.js';

export interface NavLinkRenderState {
  isActive: boolean;
  isPending: boolean;
  isTransitioning: boolean;
}

export interface RoutedNavLinkProps extends Omit<
  RouterNavLinkProps,
  'children'
> {
  label: string;
  tooltip?: string;
  disableActiveState?: boolean;
  children?: ReactNode | ((state: NavLinkRenderState) => ReactNode);
}

/**
 * Wraps Atlas's NavLink web component in react-router-dom-v5-compat's NavLink,
 * mirroring the pattern Atlas's own RoutedNavLink uses against react-router v7 —
 * this repo is on v5 + v5-compat and isn't upgrading just for the nav bar.
 */
export const RoutedNavLink = ({
  label,
  tooltip,
  children,
  disableActiveState,
  ...navLinkProps
}: RoutedNavLinkProps) => (
  <RouterNavLink data-testid="routed-nav-link" {...navLinkProps}>
    {(state) => (
      <AtlasNavLink
        as="span"
        label={label}
        tooltip={tooltip}
        isCurrent={state.isActive && !disableActiveState}
      >
        {typeof children === 'function' ? children(state) : children}
      </AtlasNavLink>
    )}
  </RouterNavLink>
);
